module.exports = __webpack_public_path__ + "img/logo.a3187866.png";